export class Modals {
    // source: https://stackoverflow.com/questions/4068373/center-a-popup-window-on-screen
    static popupCenter(url: string, title: string, w: number, h: number): Window {
        // Fixes dual-screen position                         Most browsers      Firefox
        const dualScreenLeft = window.screenLeft;
        const dualScreenTop = window.screenTop;

        const width = window.innerWidth ?? document.documentElement.clientWidth ?? screen.width;
        const height = window.innerHeight ?? document.documentElement.clientHeight ?? screen.height;

        const left = ((width / 2) - (w / 2)) + dualScreenLeft;
        const top = ((height / 2) - (h / 2)) + dualScreenTop;
        const newWindow = window.open(url, title, 'scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

        // Puts focus on the newWindow
        newWindow!.focus();
        return newWindow!;
    }
}
